import Sidebar from "../Sidebar";

const IntegrationsOverview = ({ setAuth, setUserOrg }) => {
  return (
    <div className="w-full min-h-screen bg-white text-dark-purple font-sans flex">
      <Sidebar setAuth={setAuth} setUserOrg={setUserOrg} />
      <div
        className="flex flex-col gap-4 p-8 items-center text-center"
        style={{
          marginLeft: "var(--sidebar-width, 250px)",
          width: "calc(100% - var(--sidebar-width, 250px))",
        }}
      >
        <h1 className="text-3xl font-bold mb-4">Integrations</h1>
        <p className="opacity-80">
          Overview for integrations. Select an integration
          from the sidebar to begin.
        </p>
      </div>
    </div>
  );
};

export default IntegrationsOverview;